<template>
  <div class="relative">
    <div
      class="border-b-3 border-app-color pb-10 mb-20"
    >
      <div class="group flex items-center justify-between">
        <div v-if="!isEdit" class="flex items-center">
          <p class="text-19 font-bold leading-small mr-10">{{ item.name }}</p>
          <img class="w-16 h-16 mr-5" :src="require(`@/assets/images/task-indicators/${item.id}.svg`)" alt="theme">
          <!-- <ButtonModule
            class="opacity-0 group-hover:opacity-100"
            prefix="icon-edit opacity-50 hover:opacity-100 anim-opacity text-app-color"
            @click.stop="toggleEdit"
          /> -->
        </div>
        <input
          v-else
          ref="inputRef"
          v-model="name"
          class="font-Inter text-18 bg-transparent outline-none font-extrabold leading-small pr-5"
          type="text"
          @blur="cancelEdit"
          @input="onInput"
          @keypress.enter="cancelEdit"
        >
        <p class="flex-shrink-0 text-grey-300 font-medium">{{ taskCount }}</p>
      </div>
    </div>

    <draggable
      :id="item.id"
      v-model="computedTasks"
      group="tasks"
      :delay="300"
      delay-on-touch-only="true"
      ghost-class="my-sortable-ghost-task"
      chosen-class="grab-class-task"
      drag-class="grab-class-task"
      item-key="id"
      filter=".no-drag"
      handle=".drag-handler"
      :force-fallback="true"
      :fallback-class="isDarkMode ? 'force-fallback-dark-task' : 'force-fallback-light-task'"
      class="rounded-8"
      :class="{'absolute w-full h-full': computedTasks.length === 0}"
      @add="add"
      @start="onDragSrart"
      @end="onDragEnd"
    >
      <template #item="{ element, index }">
        <Task :task="element" :style="`z-index: ${25 - index}`" @getTasks="$emit('getTasks')" />
      </template>
    </draggable>

    <NewTask
      v-if="showNewTask"
      :position="item.id"
      @getTasks="$emit('getTasks')"
      @hideNewTask="hideNewTask"
    />

    <ButtonModule
      text="new task"
      class="text-15 font-medium text-grey-700 hover:text-dark-600 relative z-10 py-8 px-10 rounded-6 anim-color-200"
      prefix="icon-add text-10 mt-2"
      :class="isDarkMode ? 'hover:bg-dark-500' : 'hover:bg-menu-hover'"
      @click.stop="newTask"
    />
  </div>
</template>

<script>
import Task from '@/components/task-board/Task'
import NewTask from '@/components/task-board/NewTask'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import draggable from 'vuedraggable'

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { taskService } from '@/services'

export default {
  components: { Task, NewTask, ButtonModule, draggable },

  props: {
    item: Object
  },

  emits: ['getTasks'],

  setup (props) {
    const { state, getters, commit, dispatch } = useStore()

    let timer = null

    const inputRef = ref(null)

    const showNewTask = ref(false)
    const isEdit = ref(false)
    const name = ref(props.item.name)

    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isTwilightTheme = computed(() => getters.isTwilightTheme)

    const taskCount = computed(() => {
      const prefix = computedTasks.value.length === 1 ? '' : 's'
      return `${computedTasks.value.length} task${prefix}`
    })

    const tasks = computed(() => state.task.tasks)

    const computedTasks = computed({
      get: () => {
        return tasks.value
          .filter(el => el.position === props.item.id.toString())
          .sort((a, b) => {
            if (a.order > b.order) return 1
            if (a.order < b.order) return -1
            return 0
          })
      },
      set: (val) => {
        const ids = {}
        val.forEach((item, index) => {
          if (!ids[item.bookId]) {
            ids[item.bookId] = [item.id]
          } else {
            ids[item.bookId].push(item.id)
          }

          commit('updateTask', { id: item.id, order: index })
        })

        setTimeout(() => {
          for (const [key, value] of Object.entries(ids)) {
            taskService.order({ ids: value, bookId: key })
          }
        }, 100)
      }
    })

    const isToday = computed(() => {
      const currentDate = new Date().getDate()
      const currentMonth = new Date().getMonth() + 1

      return +props.item.day === currentDate && +props.item.month === currentMonth
    })

    function hideNewTask () {
      showNewTask.value = false
    }

    function newTask () {
      showNewTask.value = true
    }

    function add (evt) {
      const id = parseInt(evt.item.id)
      const task = tasks.value.find(item => item.id === id)
      const newIndex = evt.newIndex
      const position = evt.to.id

      dispatch('updateTask', {
        id: id,
        order: newIndex,
        position,
        bookId: task.bookId
      })

      commit('updateTask', {
        id: id,
        order: newIndex,
        position
      })
    }

    function toggleEdit () {
      isEdit.value = !isEdit.value

      if (isEdit.value) {
        setTimeout(() => {
          inputRef.value.focus()
          inputRef.value.setSelectionRange(0, 9999)
        }, 100)
      }
    }

    function onDragSrart () {
      document.body.classList.add('grabbing')
    }

    function onDragEnd () {
      document.body.classList.remove('grabbing')
    }

    function saveName () {
      if (name.value.trim() !== '' && name.value !== props.item.name) {
        //
      }
    }

    function cancelEdit () {
      if (isEdit.value) {
        saveName()
        isEdit.value = false
      }
    }

    function onInput () {
      clearTimeout(timer)

      timer = setTimeout(() => {
        saveName()
      }, 300)
    }

    return {
      // refs
      inputRef,
      // data
      name,
      isEdit,
      showNewTask,
      // computeds
      isMobile,
      isDarkMode,
      isToday,
      taskCount,
      computedTasks,
      isTwilightTheme,
      // functions
      newTask,
      hideNewTask,
      add,
      onDragSrart,
      onDragEnd,
      toggleEdit,
      cancelEdit,
      saveName,
      onInput
    }
  }
}
</script>

<style lang="scss">
.my-sortable-ghost-task {
  max-height: 4px;
  height: 4px;
  min-height: 4px;
  padding: 0;
  box-shadow: none;
  background: var(--link-color);
}
.my-sortable-ghost-task div {
  display: none;
}

.grab-class-task {
  opacity: .5;
  cursor: grab !important;
  border: none;
  box-shadow: none;

  &:active {
    cursor: grabbing !important;
  }
}

.force-fallback-light-task {
  @apply shadow-event;
  min-height: 120px;
}

.force-fallback-dark-task {
  @apply border-2 border-grey-500;
  min-height: 45px;
}
</style>
